import dayjs from 'dayjs';

export function dateToInputValue(date: string) {
	return dayjs(date).format('YYYY-MM-DD');
}
